import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=fce06724&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=fce06724&prod&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=fce06724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce06724",
  null
  
)

export default component.exports